module.exports = fox._r("images/slides/slide_1_5.jpg", __webpack_public_path__ + "images/slides/slide_1_5.jpg");


//////////////////
// WEBPACK FOOTER
// ./images/slides/slide_1_5.jpg
// module id = 508
// module chunks = 2